import React from "react";
import { Link, useLocation } from "react-router-dom";

interface UnderlineLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  activeColor?: string; // couleur de la bordure quand actif (ex: "bg-amber-500")
  inactiveColor?: string; // couleur de la bordure au hover (ex: "bg-purple-500")
  exact?: boolean;
}

export const UnderlineLink: React.FC<UnderlineLinkProps> = ({
  to,
  children,
  className = "",
  activeColor = "bg-purple-500",
  inactiveColor = "bg-purple-500",
  exact = false,
}) => {
  const location = useLocation();
  const isActive = exact ? location.pathname === to : location.pathname.startsWith(to);

  return (
    <Link
      to={to}
      className={`relative group inline-flex items-center gap-1.5 py-0.5 px-1.5 rounded hover:bg-gray-50 transition-colors duration-200 ${className}`}
    >
      {children}
      <span
        className={`
          absolute bottom-0 left-0 h-0.5
          transition-all duration-300 ease-out
          ${isActive ? "w-full" : "w-0 group-hover:w-full"}
          ${isActive ? activeColor : inactiveColor}
        `}
      />
    </Link>
  );
};